import React, { useState } from 'react';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { STORIES } from '../data/mock';
import { InlineText, InlineImage } from './InlineEditable';

export default function StoriesSection() {
  const [i, setI] = useState(0);
  const s = STORIES[i];
  const nextStory = STORIES[(i + 1) % STORIES.length];
  const id = s.id;
  const nextId = nextStory.id;

  return (
    <section className="relative bg-cream overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <InlineText settingKey="home_stories_kicker" fallback="Bursiyer Hikâyeleri" as="div"
              className="text-[11px] tracking-[0.3em] uppercase text-coral-300 font-semibold" />
            <InlineText settingKey="home_stories_title"
              fallback={'Her burs, bir <span class="italic">hayat</span> hikâyesi.'}
              as="h2" html multiline
              className="font-display text-4xl md:text-5xl lg:text-[56px] mt-4 leading-[1.02] text-ink-600" />
            <div className="mt-8 relative">
              <Quote className="w-10 h-10 text-gold" />
              <InlineText settingKey={`story_${id}_quote`} fallback={s.quote} as="p" multiline
                className="mt-4 font-display text-2xl md:text-[26px] leading-snug text-ink-600 italic" />
              <div className="mt-6 flex items-center gap-4">
                <div className="w-14 h-14 rounded-full overflow-hidden ring-2 ring-gold/60">
                  <InlineImage settingKey={`story_${id}_image`} fallback={s.image} alt={s.name}
                    className="w-full h-full object-cover" style={{ width: '100%', height: '100%' }} />
                </div>
                <div>
                  <InlineText settingKey={`story_${id}_name`} fallback={s.name} as="div"
                    className="font-semibold text-ink-600" />
                  <div className="text-sm text-ink-400 flex items-center gap-1.5 flex-wrap">
                    <InlineText settingKey={`story_${id}_role`} fallback={s.role} as="span" />
                    <span>·</span>
                    <InlineText settingKey={`story_${id}_city`} fallback={s.city} as="span" />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-10 flex items-center gap-2">
              <button onClick={() => setI((i - 1 + STORIES.length) % STORIES.length)} className="w-11 h-11 rounded-full border border-ink-200 grid place-items-center text-ink-600 hover:bg-ink-600 hover:text-cream hover:border-ink-600 transition-colors"><ChevronLeft className="w-4 h-4" /></button>
              <button onClick={() => setI((i + 1) % STORIES.length)} className="w-11 h-11 rounded-full border border-ink-200 grid place-items-center text-ink-600 hover:bg-ink-600 hover:text-cream hover:border-ink-600 transition-colors"><ChevronRight className="w-4 h-4" /></button>
              <div className="ml-4 text-sm text-ink-400 tabular">0{i + 1} / 0{STORIES.length}</div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2 relative">
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-7 aspect-[3/4] rounded-3xl overflow-hidden shadow-xl">
                <InlineImage settingKey={`story_${id}_image`} fallback={s.image} alt=""
                  className="w-full h-full object-cover" style={{ width: '100%', height: '100%' }} />
              </div>
              <div className="col-span-5 flex flex-col gap-3">
                <div className="aspect-square rounded-3xl overflow-hidden shadow-xl">
                  <InlineImage settingKey={`story_${nextId}_image`} fallback={nextStory.image} alt=""
                    className="w-full h-full object-cover" style={{ width: '100%', height: '100%' }} />
                </div>
                <div className="flex-1 rounded-3xl bg-ink-600 text-cream p-6 shadow-xl flex flex-col justify-between">
                  <div>
                    <InlineText settingKey="home_stories_badge_kicker" fallback="YEKÜV'de" as="div"
                      className="text-[10px] uppercase tracking-widest text-gold" />
                    <InlineText settingKey="home_stories_badge_line1" fallback="BİZİM" as="div"
                      className="font-display text-4xl mt-2 leading-none" />
                    <InlineText settingKey="home_stories_badge_line2" fallback="AILEMIZ" as="div"
                      className="font-display text-4xl italic leading-none text-coral-200" />
                  </div>
                  <InlineText settingKey="home_stories_badge_sub" fallback="33 yıldan fazla." as="div"
                    className="text-xs text-cream/60 mt-4" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
